// services/ReporteResumen.js
import Api from '@/services/Api'

export default {
    // ===== REPORTES =====
    getAllReportes() { return Api().get('reporteResumen/reportes') },
    createReporte(info) { return Api().post('reporteResumen/reportes', info) },
    updateReporte(info) { return Api().put('reporteResumen/reportes', info) },
    deleteReporte(id) { return Api().delete('reporteResumen/reportes/' + id) },

    // ===== GRUPOS =====
    getGruposByReporte(reporte) { return Api().get('reporteResumen/grupos?reporte=' + reporte) },
    createGrupo(info) { return Api().post('reporteResumen/grupos', info) },
    updateGrupo(info) { return Api().put('reporteResumen/grupos', info) },
    deleteGrupo(id) { return Api().delete('reporteResumen/grupos/' + id) },

    // ===== CÓDIGOS =====
    getCodigosByGrupo(reporte, grupo) {
        const q = grupo ? `&grupo=${grupo}` : ''
        return Api().get(`reporteResumen/codigos?reporte=${reporte}${q}`)
    },
    getCodigosByReporte(reporte) { return Api().get('reporteResumen/codigosByReporte?reporte=' + reporte) },
    createCodigo(info) { return Api().post('reporteResumen/codigos', info) },
    updateCodigo(info) { return Api().put('reporteResumen/codigos', info) },
    updateCodigoMaestro(info) { return Api().put('reporteResumen/codigosMaestros', info) },
    deleteCodigoMaestro(id) { return Api().delete('reporteResumen/codigos/' + id) },

    // ===== CUENTAS =====
    getCuentasDisponibles(reporte) { return Api().get('reporteResumen/cuentasDisponibles?reporte=' + reporte) },
    getCuentasByCodigo(reporte, codigo) {
        return Api().get(`reporteResumen/cuentasByCodigo?reporte=${reporte}&codigo=${codigo}`)
    },
    updateCuentasCodigo(info) { return Api().put('reporteResumen/cuentasByCodigo', info) },

    // ===== FILAS DE CUENTAS =====
    createCuentaFila(info) { return Api().post('reporteResumen/cuentasFila', info) },
    updateCuentaFila(info) { return Api().put('reporteResumen/cuentasFila', info) },
    deleteCuentaFila(idCuenta, idCodigo) {
        const url = idCodigo
            ? `reporteResumen/cuentasFila/${idCuenta || 0}/${idCodigo}`
            : `reporteResumen/cuentasFila/${idCuenta}`
        return Api().delete(url)
    },

    // ===== CIIU =====
    getCiius() { return Api().get('reporteResumen/ciius') },
}